export default __webpack_public_path__ + "static/media/brand6.6e092d92.svg";